import { type WishlistItem } from "@/services/api/wishlist";

interface WishlistItemCardProps {
  item: WishlistItem;
}

const WishlistItemCard: React.FC<WishlistItemCardProps> = () => {
  return (
    <div className="border border-gray-200 hover:border-gray-400 transition-colors">
      
    </div>
  );
};

export default WishlistItemCard;